import { roadmapLink } from '@/components/landing/Footer'
import { useEffect } from 'react'

export default function Roadmap() {
  useEffect(() => {
    window.location.replace(roadmapLink)
  }, [])

  return null
}
